export default {
  getMsAccount: (state) => state.msAccount
  // getAccessToken: (state) => () => {
  //   return state.accessToken
  // },
  // getUserData: (state) => () => {
  //   return state.userData
  // },
}